import "core-js/stable";
import "regenerator-runtime/runtime";
import { createApp } from "vue";

// Gallery Component
const gallery = async () => {
    var timer = 0;

    // Create our vue instance
    const galleryVM = createApp({
        compilerOptions: { delimiters: ["${", "}"] },
        components: {},
        data: ()=>({
            currentSlide: 1,
            totalSlides: 0,
            autoPlay: true,
            autoPlaySpeed: 3,
        }),
        methods: {
            init: function () {
                this.totalSlides = this.$refs.slides.children.length;

                if (this.autoPlay) {
                    this.start();
                }
            },
            start: function () {
                let s = this;
                timer = setInterval(() => {
                    s.nextSlide();
                }, this.autoPlaySpeed * 1000);
            },
            stop: function () {
                clearInterval(timer);
            },
            nextSlide: function () {
                if (this.currentSlide < this.totalSlides) {
                    this.currentSlide = this.currentSlide + 1;
                } else {
                    this.currentSlide = 1;
                }
            },
        },

        computed: {},

        mounted() {
            console.log("Gallery VUE is Ready, ok");
            this.$nextTick(function () {
                this.init();
            });
        },
    });

    const root = galleryVM.mount("#gallery-vue");
    return root;
};

// Execute async function
gallery()
    .then((value) => {
        console.log("Vue Gallery component mounted");
    })
    .catch((err) => {
        console.log("Error mounting Vue Gallery component");
    });

export default gallery;
